import os from 'os'

const AWS = require('aws-sdk')
let apiProtocol = 'https://'
let sslProtocol = 'https://'

//Use during SSL
//const productionAPIHost = 'api.healthsetgo.com'
//const productionURLs = ['healthsetgo.com', productionAPIHost]
//const productionAPIPort = ''

const productionAPIHost = 'giis-api.healthsetgo.online'
const productionURLs = ['localhost', productionAPIHost]
const productionAPIPort = ''

const stagingAPIHost = '3.1.0.113:8090'
const stagingURLs = ['localhost', stagingAPIHost]
const stagingAPIPort = ''


//----------- PRODUCTION SECTION ----------------//
//const apiHost = productionAPIHost
//const devPort = ''
//const apiPort = productionAPIPort
//const apiUrl = sslProtocol + apiHost
//const s3URL = "http://hsgbucket.s3.amazonaws.com"



//----------- STAGING SECTION ----------------//
const apiHost = productionAPIHost
const devPort = ''
const apiPort = productionAPIPort
const apiUrl = apiProtocol + apiHost
const s3URLHSG = "http://hsgbucket.s3.amazonaws.com"
const s3URLGIIS = "https://giisbucket.s3.amazonaws.com"
const s3URL = s3URLGIIS
AWS.config.update({accessKeyId: 'AKIA4QJ4GI2OTEX3AZEV',
 secretAccessKey: '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', 
 region: "ap-southeast-1"})

const s3 = new AWS.S3()
const s3BucketName = 'giisbucket'
const s3BucketKey = 'web-resources/public/school/'
const s3signedUrlExpireSeconds = 60 * 15


const qcCheckedStatusMap = {
  CHECKED: 45,
  PUBLISHED: 46
}

const activeStatusMap = {
  ACTIVE: 1,
  DRAFT: 2,
  DELETE: 3
}

const orgTypeMap = {
  SCHOOL: 1,
  MSP: 2,
  ISP: 3
}

const allTabsMap = {
  SCHOOL: 'school',
  QC: 'qc',
  QC_DETAIL: 'qc-detail',
  TC: 'tc',
  MANAGER: 'manager'
}

//---------- CONSTANTS USED FOR CLIENT -----------//

const roles = {
  1: { value: 'HSG OPS', orgActive: 
    {
      [orgTypeMap.SCHOOL] : `{${activeStatusMap.ACTIVE},${activeStatusMap.DRAFT}}`,
      [orgTypeMap.MSP] : `{${activeStatusMap.ACTIVE}}`,
      [orgTypeMap.ISP] : `{${activeStatusMap.ACTIVE}}`
    }
  },
  2: { value: 'HSG Finance' },
  //3: { value: 'HSG Community Manager' },
  4: { value: 'School Admin' },
  5: { value: 'Parent' },
  6: { value: 'Finance team' },
  7: { value: 'In-house doctor/CHM' },
  3: { value: 'CHM', detail: 'Community Health Manager', orgActive: 
    {
      [orgTypeMap.SCHOOL] : `{${activeStatusMap.ACTIVE}}`,
      [orgTypeMap.MSP] : `{${activeStatusMap.ACTIVE}}`,
      [orgTypeMap.ISP] : `{${activeStatusMap.ACTIVE}}`
    } 
  },
  8: { value: 'CHM Manager', orgActive: 
    {
        [orgTypeMap.SCHOOL] : `{${activeStatusMap.ACTIVE}}`
    } 
  },
  9: { value: 'Student' },
  //10: { value: 'Guest' },
  14: { value: 'HSG SA ISP', orgActive: 
    {
      [orgTypeMap.ISP] : `{${activeStatusMap.ACTIVE},${activeStatusMap.DRAFT}}`      
    }
  },
  15: { value: 'HSG SA MSP', orgActive: 
    {
      [orgTypeMap.MSP] : `{${activeStatusMap.ACTIVE},${activeStatusMap.DRAFT}}`,      
    }
  },
  17: { value: 'HSG Ops Manager', orgActive: 
    {
      [orgTypeMap.SCHOOL] : `{${activeStatusMap.ACTIVE},${activeStatusMap.DRAFT}}`,
      [orgTypeMap.MSP] : `{${activeStatusMap.ACTIVE}}`,
      [orgTypeMap.ISP] : `{${activeStatusMap.ACTIVE}}`
    }
  }
}

/* 
1 | OPS
2 | Finance
3 | CHM
4 | School Admin
5 | Parent
6 | Finance team
7 | In-house doctor/CHM
8 | CHM Manager
9 | Student
10 | Doctor
11 | Onsite Coordinator
12 | HSG Super Admin
13 | Guest
14 | SA-ISP
15 | SA-MSP
16 | CEO(Super Admin)
17 | OPS Manager


const roles = {
  'OPS_MANAGER' : {value: 'HSG Ops Manager'},
  2 : {value: 'HSG Finance'},
  3 : {value: 'HSG Community Manager'},
  4 : {value: 'School Admin'},
  5 : {value: 'Parent'},
  6 : {value: 'Finance team'},
  7 : {value: 'In-house doctor/CHM'},
  'CHM' : {value: 'CHM', detail: 'Community Health Manager'},
  9 : {value: 'Student'},
 10 : {value: 'Guest'},
} */

const getIdFromUrl = (url, pos) => {
  url = url.split('/')
  return parseInt(url[url.length - pos], 10)
}

const roleIdMap = {
  'OPS_MANAGER': 17,
  'CHM': 3,
  'CHM_MANAGER': 8,
  'SCHOOL_ADMIN': 4
}

const programIdMap = {
  'Care': 2,
  'Old Care': 692
}

/**
 * Please find the roles and its id's below
 */

/* 1 | OPS
2 | Finance
3 | CHM
4 | School Admin
5 | Parent
6 | Finance team
7 | In - house doctor / CHM
8 | CHM Manager
9 | Student
10 | Doctor
11 | Onsite Coordinator
12 | HSG Super Admin
13 | Guest
14 | SA - ISP
15 | SA - MSP
16 | CEO(Super Admin)
17 | OPS Manager */

const roleIdMapV2 = {
  'OPS_MANAGER': { value: 17, detail: 'HSG Ops Manager', orgActive: '{1,2}' },
  'CHM': { value: 3, detail: 'Community Health Manager', orgActive: '{1}' },
  'CHM_MANAGER': { value: 8, detail: 'CHM Manager', orgActive: '{1}'},
  'SCHOOL_ADMIN': { value: 4, detail: 'SCHOOL_ADMIN', orgActive: '{1}'},
  'NURSE': { value: 19, detail: 'NURSE', orgActive: '{1}'},
  'GUEST_USER': { value: 13, detail: 'GUEST_USER', orgActive: '{1}'}
}

// 31 | Created
// 32 | Scheduled
// 33 | In Progress
// 34 | Complete
// 35 | Cancelled

const eventTrackStatus = {
  CREATED: 31,
  SCHEDULED: 32,
  IN_PROGRESS: 33,
  COMPLETE: 34,
  CANCELLED: 35
}

const eventTrackRankMap = {
  START_NODE: 1,
  ONBOARD_SCHOOL: 2,
  CAREBOX: 3,
  VISION_CAREBOX: 3,
  BALANCED_CAREBOX: 3,
  SUGAR_CAREBOX: 3,
  BLOOD_DONATION_CAREBOX: 3,
  IMMUNIZATION_CAREBOX: 3,
  HEART_CAREBOX: 3,
  HYGIENE_CAREBOX: 3,
  STUDENT_LIST: 4,
  SCHEDULE_HEATH_CHECKUP: 5,
  DOWNLOAD_OMR: 6,
  HEALTH_CHECKUP: 7,
  UPLOAD_HEATH_CHECKUP_DATA: 8,
  QC: 9,
  TC: 10,
  END_NODE: 11
}

const getNode = (events, filterVal) => {
  let startNode = [];
  if (events && events.length > 0) {
    startNode = events.filter((e, i) => {
      if (Boolean(e.event_custom_json)) {
        return e.event_custom_json.name === filterVal
      }
    })
    return startNode.length > 0 ? startNode[0] : undefined
  } else return []
}


// nodeId of the Student Assessment Data Node to be excluded from View/Edit
const qcMetricsInertNodeId = 1;

const defaultRegionCodes = {
  INDIA_COUNTRY_CODE: 3
}

const userPermissionId = {
  EDIT: 1,
  ADD: 2
}
const userPermissionMap = {
  [roleIdMapV2.SCHOOL_ADMIN.value]: [
    userPermissionId.EDIT
  ],
  [roleIdMapV2.GUEST_USER.value]: [],
  [roleIdMapV2.NURSE.value]: [
    userPermissionId.ADD
  ]
}

const CustomMetaDataType = {
  StudentImageTags: 'StudentImageTags'
}

const documentCategories = {
  StudentHealthLocker: 'StudentHealthLocker',
  StudentMedicationHistory: 'StudentMedicationHistory',
  StudentVaccinations: 'StudentVaccinations',
  StudentVaccinationCompletion: 'StudentVaccinationCompletion',
  SchoolHealthLocker: 'SchoolHealthLocker',
  StudentMedicalLeave: 'StudentMedicalLeave'
}

const documentCategoryLabel = {
  StudentHealthLocker: 'Health Locker',
  StudentMedicationHistory: 'Medical History',
  StudentVaccinations: 'Vaccinations',
  StudentVaccinationCompletions: 'Vaccination Completion Certificate',
  SchoolHealthLocker: 'School Health Locker',
  StudentMedicalLeave: 'Medical Leaves',
}

const documentSubCategory ={

  // User Defined
  StudentHealthLocker: 'StudentHealthLocker',
  StudentPastAllergies: 'StudentHealthLocker',
  StudentPastMedication: 'StudentPastMedication', 
  StudentPastIllness: 'StudentPastIllness', 
  StudentPastCronic: 'StudentPastCronic',
  StudentVaccinationCertificate: 'StudentVaccinationCertificate',
  StudentMedicalLeave: 'StudentMedicalLeave',

  // Default
  Others: 'Others'

  // Rest are Auto generated
}

const documentSubCategoryLabel = {

  // User Defined Keys
  'StudentMedicalLeave': 'Medical Leaves',
  'StudentHealthLocker': 'Health Locker',
  'StudentPastAllergies': 'Past Allergies',
  'StudentPastMedication': 'Past Medication', 
  'StudentPastIllness': 'Past Illness', 
  'StudentPastCronic': 'Past Cronic',

  'StudentVaccinationCertificate': 'Vaccination Certificate',

  'others': 'Others',
  
  //Auto Generated Keys
  'student-20-hepatitis-a': 'hepatitis a',
  'student-18-dpt-opv-hib': 'dpt opv hib',
  'student-1-bcg': 'bgc',
  'student-16-measels': 'measels',
  'student-17-mmr': 'mmr',
  'student-19-typhoid': 'typhoid',
  'student-21-chicken-pox': 'chichen-pox',
  'student-22-dt-opa': 'dt opa',
  'student-11-oral-polio': 'oral polio',
  'student-12-oral-polio': 'oral polio',
  'student-13-oral-polio': 'oral polio',
  'student-14-oral-polio': 'oral polio',
  'student-15-oral-polio': 'oral polio',
  'student-8-hb': 'hb',
  'student-9-hb': 'hb',
  'student-10-hb': 'hb',
  'student-5-dpt': 'dpt',
  'student-6-dpt': 'dpt',
  'student-7-dpt': 'dpt',
  'student-2-hepatitis-b': 'hepatitis b',
  'student-3-hepatitis-b': 'hepatitis b',
  'student-4-hepatitis-b': 'hepatitis b',
  'student-23-typhoid': 'typhoid',
  'student-24-tt': 'tt',
  'student-25-influenza': 'influenza',
  'student-26-mengiococcal': 'mengiococcal',
  'student-27-tdap': 'tdap',
  'student-28-hpv': 'hpv',
}

const documentGroups = {
  StudentHealthLocker: 'StudentHealthLocker',
  SchoolHealthLocker: 'SchoolHealthLocker'
}

const getCategorizedDocuments = (documents) => {
  let categories = {}

  documents.map((docs, index)=>{

    let type, subType
    let custom = JSON.parse(docs.custom_field)[0]
    let json = custom.json_value
    let obj = {
      // Meta
      id: docs.id,
      uuid: docs.uuid,
      nodeId: docs.node_id,
      docMeta: json,
      uploaded: new Date(custom.created_time),

    //Content
      // contentPrivateUrl: json.content_url,
      mimeType: json.mimeType,
      contentUrl:formatURL(json.content_url), //S3 Signed URL

      //Content
      type: json.type,
      subType: json.subType,
      fileName: json.file_name,
    }
    
    type = custom.json_value.type
    subType = custom.json_value.subType
    categories = {...categories}
    let catArrray = categories[type] || []
    catArrray.push(obj)

    categories[type] = catArrray
  }) 

  return categories

}

const episodeIdMap = {
  EPISODE: 1,
  ANTHROPOMETRIC: 2,
  VITALS: 3,
  EYE: 4
}

const alertTypeMap = {
  ALERTS: 'alert',
  MSG: 'msg'
}

const alertStatus = {
  ACTIVE: 101,
  FETCH: 102,
  SEND: 103,
  ERROR: 104
}

const defaultDateFormat = "DD MMM YYYY"
 function formatURL(fileURL) {

  if (!fileURL) {
      return null
  }
  let possiblePic, possibleStage
  
  possiblePic = fileURL && fileURL.split ? fileURL.replaceAll('%2F','/').split("/") : []
  possibleStage = fileURL && fileURL.split ? fileURL.split("blob") : []
  let base = possiblePic[possiblePic.length - 2]
  let name = possiblePic[possiblePic.length - 1]
  return name ? getS3ImageSignedURL(base?`${base}/${name}`:name) : null
}
function getS3ImageSignedURL(name) {
  
  //   if (params.Authorization && params.Signature) {
  //       const credentials = params.Credential.split("/")
  //       const signature = hmacSHA512(
  //           hmacSHA512(hmacSHA512(hmacSHA512("AWS4" + credentials[0], credentials[1]), credentials[2]), credentials[3]),
  //           credentials[4]
  //       )
  //       return `${url}?AWSAccessKeyId=${credentials[0]}&Expires=1599092954&Signature=${params.Signature}`
  //     //   return `${url}?X-Amz-Algorithm=${params.Authorization}&X-Amz-Credential=${params.Credential}&X-Amz-Date=${params["Signed-Headers"]}&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=${params.Signature}`
  //   }
  let fileName = name && typeof name === 'string' ? decodeURI(name) : name
  fileName = fileName && typeof fileName === 'string' ? fileName.replace(/\+/g, ' ') : fileName
  const params = { Bucket: s3BucketName, Key: 'web-resources/public/school/' + fileName, Expires: s3signedUrlExpireSeconds }
  const url = s3.getSignedUrl("getObject", {...params})
  return url
}
export default {
  
  defaultDateFormat,

  alertTypeMap,
  alertStatus,
  
  episodeIdMap,
  getCategorizedDocuments,
  documentGroups,
  documentSubCategoryLabel,
  documentSubCategory,
  documentCategoryLabel,
  documentCategories,
  CustomMetaDataType,

  userPermissionMap,
  userPermissionId,
  programIdMap,
  getNode,
  getIdFromUrl,
  roles,
  roleIdMap,
  roleIdMapV2,
  apiUrl,
  apiHost,
  apiProtocol,
  sslProtocol,
  devPort,
  apiPort,
  s3URL,
  activeStatusMap,
  orgTypeMap,
  eventTrackStatus,
  qcCheckedStatusMap,
  qcMetricsInertNodeId,
  eventTrackRankMap,
  allTabsMap,
  defaultRegionCodes
}



// WEBPACK FOOTER //
// ./src/Phi/Constants.js